export var ArticleSearchResultDocumentType;
(function (ArticleSearchResultDocumentType) {
    ArticleSearchResultDocumentType["ANSWERS_ARTICLE"] = "ANSWERS_ARTICLE";
    ArticleSearchResultDocumentType["WIX_DOCS_ARTICLE"] = "WIX_DOCS_ARTICLE";
    ArticleSearchResultDocumentType["UNKNOWN_RELATED_DOCUMENT_TYPE"] = "UNKNOWN_RELATED_DOCUMENT_TYPE";
    ArticleSearchResultDocumentType["WIX_FORUM_TOPIC"] = "WIX_FORUM_TOPIC";
    ArticleSearchResultDocumentType["WIX_STUDIO_ACADEMY"] = "WIX_STUDIO_ACADEMY";
})(ArticleSearchResultDocumentType || (ArticleSearchResultDocumentType = {}));
export var DeviceType;
(function (DeviceType) {
    DeviceType["MOBILE"] = "MOBILE";
    DeviceType["DESKTOP"] = "DESKTOP";
})(DeviceType || (DeviceType = {}));
export var ConsumerSource;
(function (ConsumerSource) {
    ConsumerSource["WIDGET"] = "widget";
    ConsumerSource["HELP_CENTER"] = "helpCenter";
})(ConsumerSource || (ConsumerSource = {}));
//# sourceMappingURL=types.js.map